import { unsubscribeAccount } from '../../services/APIService'

/**
 * Function to unsubscribe the panel user.
 * @param commit
 * @param uh
 * @param email
 * @param reason
 * @param group
 * @param mail_user_subject ------> The mail for the user
 * @param mail_user_message
 * @param mail_action_subject -------> The mail for the moderator
 * @param mail_action_message
 * @returns {Promise<void>}
 */
export const unsubscribe = async ({ commit }, { uh, email, reason, group, mail_user_subject, mail_user_message, mail_action_subject, mail_action_message }) => {
    return unsubscribeAccount(uh, email, reason, group, mail_user_subject, mail_user_message, mail_action_subject, mail_action_message)
}
